export default "__VITE_ASSET__CBifcLFK__"